import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Camera, Video, Mic, FileText, Plus, X } from 'lucide-react';

export default function FloatingCapture() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const actions = [
    { icon: Camera, label: 'Photo', color: 'bg-tan-500', route: '/camera' },
    { icon: Video, label: 'Video', color: 'bg-rose-500', route: '/camera?mode=video' },
    { icon: Mic, label: 'Voice', color: 'bg-violet-500', route: '/camera?mode=voice' },
  ];

  return (
    <div className="hidden lg:block fixed bottom-8 right-8 z-30" data-testid="floating-capture">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-16 right-0 bg-[#141414] rounded-2xl shadow-xl border border-[#1C1C1C] p-2 min-w-[160px]"
          >
            {actions.map((action, i) => {
              const Icon = action.icon;
              return (
                <motion.button
                  key={i}
                  initial={{ opacity: 0, x: 8 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.05 }}
                  onClick={() => { setOpen(false); navigate(action.route); }}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#0F0F0F] transition-colors text-left"
                  data-testid={`capture-${action.label.toLowerCase()}`}
                >
                  <div className={`w-8 h-8 rounded-lg ${action.color} flex items-center justify-center`}>
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-sm font-medium text-stone-200">{action.label}</span>
                </motion.button>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-colors ${
          open ? 'bg-stone-700' : 'bg-primary'
        }`}
        data-testid="capture-fab"
        style={{ transition: 'transform 0.2s, background-color 0.2s' }}
      >
        {open ? <X className="w-5 h-5 text-white" /> : <Plus className="w-5 h-5 text-white" />}
      </motion.button>
    </div>
  );
}
